import { useCallback, useEffect, useState } from 'react'

import { toPascalCase } from 'app/utils'


const transformers = {
    executionDay: value => {
        if (!Array.isArray(value)) return value
        const hasDaily = value.some(item => item.value === 'daily')
        return hasDaily
            ? value.filter(item => item.value === 'daily')
            : value.slice(0, 3)
    },
    executionHour: value => {
        return Array.isArray(value) ? value.slice(0, 2) : value
    },
    leadTimeDays: value => {
        const parsed = parseInt(value, 10)
        return isNaN(parsed) ? '' : Math.min(parsed, 120).toString()
    }
}

export default function useAppFormHandler(key, value, setter, isLoading, onReady) {

    const [state, setState] = useState(value)

    useEffect(() => {
        if (isLoading) {
            setter(state)
            onReady?.()
        }
        // eslint-disable-next-line
    }, [isLoading])

    const setFieldValue = useCallback(newState => {
        const transform = transformers[key]
        const processedValue = transform ? transform(newState) : newState
        setState(processedValue)
    }, [key, setState])


    return {
        [key]: state,
        [`on${toPascalCase(key)}Change`]: setFieldValue
    }
}